import {
  arrayOf,
  alias,
  namedFragment, number, params, shape, string,
} from '@thd-nucleus/data-sources';

export const dataModel = {
  quickLinks: alias('component').params({
    id: string().isRequired(),
  }).shape({
    AnchorLinks: namedFragment({
      inline: true,
      fragmentType: 'AnchorLinks'
    }).shape({
      id: string(),
      linkList: arrayOf(namedFragment({
        inline: true,
        fragmentType: 'Link'
      }).shape({
        id: string(),
        href: string(),
        label: string(),
      })),
    })
  })
};